var _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAndelogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "_\\u0421\\u043B\\u043E\\u0439_1",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 1",
    viewBox: "0 0 512 76",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #00e3d2;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #007269;\r\n      }\r\n\r\n      .cls-3 {\r\n        fill: #000d15;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m110.76,6.3h14.42l11.03,67.75h-10.65l-1.94-13.45v.19h-12.1l-1.94,13.26h-9.87L110.76,6.3Zm11.61,45.29l-4.74-33.49h-.19l-4.65,33.49h9.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m141.34,6.3h13.36l10.36,40.55h.19V6.3h9.48v67.75h-10.94l-12.77-49.46h-.19v49.46h-9.48V6.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m182.66,6.3h16.26c5.29,0,9.26,1.42,11.9,4.26,2.65,2.84,3.97,7,3.97,12.48v34.26c0,5.48-1.32,9.65-3.97,12.48-2.65,2.84-6.61,4.26-11.9,4.26h-16.26V6.3Zm16.07,58.07c1.74,0,3.08-.52,4.02-1.55.93-1.03,1.4-2.71,1.4-5.03V22.56c0-2.32-.47-4-1.4-5.03-.94-1.03-2.27-1.55-4.02-1.55h-5.42v48.39h5.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m221.96,6.3h29.03v9.68h-18.39v17.9h14.61v9.68h-14.61v20.81h18.39v9.68h-29.03V6.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m272.57,6.3h28.16v9.68h-17.52v18.87h13.74v9.68h-13.74v29.52h-10.65V6.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m305.86,6.3h10.65v67.75h-10.65V6.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m324.44,6.3h13.36l10.36,40.55h.19V6.3h9.48v67.75h-10.94l-12.78-49.46h-.19v49.46h-9.49V6.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m373.99,6.3h14.42l11.03,67.75h-10.65l-1.94-13.45v.19h-12.1l-1.94,13.26h-9.87l11.03-67.75Zm11.61,45.29l-4.74-33.49h-.19l-4.65,33.49h9.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m404.57,6.3h13.36l10.36,40.55h.19V6.3h9.48v67.75h-10.94l-12.78-49.46h-.19v49.46h-9.49V6.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m449.24,70.66c-2.68-2.9-4.02-7-4.02-12.29V21.98c0-5.29,1.34-9.39,4.02-12.29,2.68-2.9,6.56-4.36,11.66-4.36s8.98,1.45,11.66,4.36c2.68,2.9,4.02,7,4.02,12.29v7.16h-10.07v-7.84c0-4.19-1.77-6.29-5.32-6.29s-5.32,2.1-5.32,6.29v37.84c0,4.13,1.77,6.19,5.32,6.19s5.32-2.06,5.32-6.19v-10.36h10.07v9.58c0,5.29-1.34,9.39-4.02,12.29-2.68,2.9-6.57,4.35-11.66,4.35s-8.99-1.45-11.66-4.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m482.97,6.3h29.03v9.68h-18.39v17.9h14.61v9.68h-14.61v20.81h18.39v9.68h-29.03V6.3Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "22.33 .4 22.33 55.14 .17 75.02 0 75.02 0 .4 22.33 .4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "52.59 .69 52.59 28 30.26 48.02 30.26 .69 52.59 .69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "82.71 .98 60.52 20.88 60.52 .98 82.71 .98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "82.85 .98 82.85 75.6 60.52 75.6 60.52 20.88 82.71 .98 82.85 .98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "52.59 28 52.59 75.31 30.26 75.31 30.26 48.02 52.59 28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "22.33 55.14 22.33 75.02 .17 75.02 22.33 55.14"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAndelogo);
export default __webpack_public_path__ + "static/media/andelogo.83202b4df1e4319cf3ae54a573dac3c0.svg";
export { ForwardRef as ReactComponent };